export default "__VITE_ASSET__lma_WWCM__"